import apiService from './api.js';

export const portfoliosService = {
  // Carteiras
  async getPortfolios() {
    try {
      const response = await apiService.get('/portfolios');
      return response.data;
    } catch (error) {
      // Error handled by API service
      throw error;
    }
  },

  async getPortfolioById(portfolioId) {
    try {
      const response = await apiService.get(`/portfolios/${portfolioId}`);
      return response.data;
    } catch (error) {
      // Error handled by API service
      throw error;
    }
  },

  async createPortfolio(portfolioData) {
    try {
      const response = await apiService.post('/portfolios', portfolioData);
      return response.data;
    } catch (error) {
      // Error handled by API service
      throw error;
    }
  },

  async updatePortfolio(portfolioId, portfolioData) {
    try {
      const response = await apiService.put(`/portfolios/${portfolioId}`, portfolioData);
      return response.data;
    } catch (error) {
      // Error handled by API service
      throw error;
    }
  },

  async deletePortfolio(portfolioId) {
    try {
      const response = await apiService.delete(`/portfolios/${portfolioId}`);
      return response.data;
    } catch (error) {
      // Error handled by API service
      throw error;
    }
  },

  // Performance
  async getPortfolioPerformance(portfolioId) {
    try {
      const response = await apiService.get(`/portfolios/${portfolioId}/performance`);
      return response.data;
    } catch (error) {
      // Error handled by API service
      throw error;
    }
  },

  // Métricas
  async getPortfolioMetrics() {
    try {
      const response = await apiService.get('/portfolios/metrics');
      return response.data;
    } catch (error) {
      // Error handled by API service
      throw error;
    }
  }
};